import { PrivilegeDto, PrivilegeEnum } from './ApiClient';
import { Operation } from '@/stores/authStore';

/**
 * Checks if a user is authorized to perform a specific operation based on their privileges
 * @param currentUserPrivileges - The privileges of the current user
 * @param privilegeId - The enum (ID) of the privilege to check
 * @param operation - The operation to verify ('read', 'write', 'execute', etc.)
 * @returns boolean indicating whether the user is authorized
 */
export function isAuthorized(
  currentUserPrivileges: PrivilegeDto[],
  privilegeId: PrivilegeEnum,
  operation: Operation
): boolean {
  // Find the specific privilege within the privileges array
  const privilege = currentUserPrivileges?.find((priv) => priv.id === privilegeId);

  // If privilege not found, deny access
  if (!privilege) return false;

  // Convert operation to single character for rights string comparison
  const operationChar = operation === 'execute' ? 'x' : operation === 'reset' ? 'p' : operation[0];

  // Check if the operation character exists in the rights string
  return (privilege.rights ?? '').indexOf(operationChar) > -1;
}
